import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  EntityLink,
  EntityLinkQuery,
  CreateEntityLinkInput,
  UpdateEntityLinkInput,
} from '@peles/shared';
import * as entityLinksApi from '../api/entity-links';

export function useEntityLinks(query: EntityLinkQuery) {
  return useQuery<EntityLink[]>({
    queryKey: ['entity-links', query],
    queryFn: () => entityLinksApi.listEntityLinks(query),
    enabled:
      !!(query.sourceEntityType && query.sourceEntityId) ||
      !!(query.targetEntityType && query.targetEntityId),
  });
}

export function useCreateEntityLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateEntityLinkInput) => entityLinksApi.createEntityLink(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entity-links'] });
    },
  });
}

export function useUpdateEntityLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: UpdateEntityLinkInput }) =>
      entityLinksApi.updateEntityLink(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entity-links'] });
    },
  });
}

export function useDeleteEntityLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => entityLinksApi.deleteEntityLink(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entity-links'] });
    },
  });
}
